/*!
 *
 *   @bornfight/gocart v1.0.9
 *
 *
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *
 */
!(function (t, e) {
  "object" === typeof exports && "object" === typeof module
    ? (module.exports = e())
    : "function" === typeof define && define.amd
      ? define("GoCart", [], e)
      : "object" === typeof exports
        ? (exports.GoCart = e())
        : (t.GoCart = e());
})(window, function () {
  return (function (t) {
    var e = {};
    function __webpack_require__(r) {
      if (e[r]) return e[r].exports;
      var a = (e[r] = { i: r, l: !1, exports: {} });
      return (
        t[r].call(a.exports, a, a.exports, __webpack_require__),
        (a.l = !0),
        a.exports
      );
    }
    return (
      (__webpack_require__.m = t),
      (__webpack_require__.c = e),
      (__webpack_require__.d = function (t, e, r) {
        __webpack_require__.o(t, e) ||
          Object.defineProperty(t, e, { enumerable: !0, get: r });
      }),
      (__webpack_require__.r = function (t) {
        ("undefined" !== typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 }));
      }),
      (__webpack_require__.t = function (t, e) {
        if ((1 & e && (t = __webpack_require__(t)), 8 & e)) return t;
        if (4 & e && "object" === typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (
          (__webpack_require__.r(r),
          Object.defineProperty(r, "default", { enumerable: !0, value: t }),
          2 & e && "string" != typeof t)
        )
          for (var a in t)
            __webpack_require__.d(
              r,
              a,
              function (e) {
                return t[e];
              }.bind(null, a),
            );
        return r;
      }),
      (__webpack_require__.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return (__webpack_require__.d(e, "a", e), e);
      }),
      (__webpack_require__.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (__webpack_require__.p = ""),
      __webpack_require__((__webpack_require__.s = 1))
    );
  })([
    function (t, e, r) {
      var a = r(3),
        o = /^(?:submit|button|image|reset|file)$/i,
        n = /^(?:input|select|textarea|keygen)/i,
        i = /(\[[^\[\]]*\])/g;
      function hash_serializer(t, e, r) {
        if (e.match(i)) {
          !(function hash_assign(t, e, r) {
            if (0 === e.length) return (t = r);
            var a = e.shift(),
              o = a.match(/^\[(.+?)\]$/);
            if ("[]" === a)
              return (
                (t = t || []),
                Array.isArray(t)
                  ? t.push(hash_assign(null, e, r))
                  : ((t._values = t._values || []),
                    t._values.push(hash_assign(null, e, r))),
                t
              );
            if (o) {
              var n = o[1],
                i = +n;
              isNaN(i)
                ? ((t = t || {})[n] = hash_assign(t[n], e, r))
                : ((t = t || [])[i] = hash_assign(t[i], e, r));
            } else t[a] = hash_assign(t[a], e, r);
            return t;
          })(
            t,
            (function (t) {
              var e = [],
                r = new RegExp(i),
                a = /^([^\[\]]*)/.exec(t);
              for (a[1] && e.push(a[1]); null !== (a = r.exec(t)); )
                e.push(a[1]);
              return e;
            })(e),
            r,
          );
        } else {
          var a = t[e];
          a ? (Array.isArray(a) || (t[e] = [a]), t[e].push(r)) : (t[e] = r);
        }
        return t;
      }
      function str_serialize(t, e, r) {
        return (
          (r = r.replace(/(\r)?\n/g, "\r\n")),
          (r = (r = encodeURIComponent(r)).replace(/%20/g, "+")),
          t + (t ? "&" : "") + encodeURIComponent(e) + "=" + r
        );
      }
      t.exports = function (t, e) {
        "object" != a(e)
          ? (e = { hash: !!e })
          : void 0 === e.hash && (e.hash = !0);
        for (
          var r = e.hash ? {} : "",
            i = e.serializer || (e.hash ? hash_serializer : str_serialize),
            s = t && t.elements ? t.elements : [],
            c = Object.create(null),
            l = 0;
          l < s.length;
          ++l
        ) {
          var u = s[l];
          if (
            (e.disabled || !u.disabled) &&
            u.name &&
            n.test(u.nodeName) &&
            !o.test(u.type)
          ) {
            var d = u.name,
              f = u.value;
            if (
              (("checkbox" !== u.type && "radio" !== u.type) ||
                u.checked ||
                (f = void 0),
              e.empty)
            ) {
              if (
                ("checkbox" !== u.type || u.checked || (f = ""),
                "radio" === u.type &&
                  (c[u.name] || u.checked
                    ? u.checked && (c[u.name] = !0)
                    : (c[u.name] = !1)),
                void 0 == f && "radio" == u.type)
              )
                continue;
            } else if (!f) continue;
            if ("select-multiple" !== u.type) r = i(r, d, f);
            else {
              f = [];
              for (var h = u.options, y = !1, p = 0; p < h.length; ++p) {
                var m = h[p],
                  b = e.empty && !m.value,
                  v = m.value || b;
                m.selected &&
                  v &&
                  ((y = !0),
                  (r =
                    e.hash && "[]" !== d.slice(d.length - 2)
                      ? i(r, d + "[]", m.value)
                      : i(r, d, m.value)));
              }
              !y && e.empty && (r = i(r, d, ""));
            }
          }
        }
        if (e.empty) for (var d in c) c[d] || (r = i(r, d, ""));
        return r;
      };
    },
    function (t, e, r) {
      t.exports = r(4);
    },
    function (t, e, r) {},
    function (t, e) {
      function _typeof2(t) {
        return (_typeof2 =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" === typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _typeof(e) {
        return (
          "function" === typeof Symbol && "symbol" === _typeof2(Symbol.iterator)
            ? (t.exports = _typeof =
                function (t) {
                  return _typeof2(t);
                })
            : (t.exports = _typeof =
                function (t) {
                  return t &&
                    "function" === typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : _typeof2(t);
                }),
          _typeof(e)
        );
      }
      t.exports = _typeof;
    },
    function (t, e, r) {
      "use strict";
      r.r(e);
      r(2);
      var a = "${{amount}}";
      function formatMoney(t, e) {
        "string" === typeof t && (t = t.replace(".", ""));
        var r = "",
          o = /\{\{\s*(\w+)\s*\}\}/,
          n = e || a;
        function formatWithDelimiters(t) {
          var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 2,
            r =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : ",",
            a =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : ".";
          if (isNaN(t) || null == t) return 0;
          var o = (t = (t / 100).toFixed(e)).split(".");
          return (
            o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(r)) +
            (o[1] ? a + o[1] : "")
          );
        }
        switch (n.match(o)[1]) {
          case "amount":
            r = formatWithDelimiters(t, 2);
            break;
          case "amount_no_decimals":
            r = formatWithDelimiters(t, 0);
            break;
          case "amount_with_comma_separator":
            r = formatWithDelimiters(t, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            r = formatWithDelimiters(t, 0, ".", ",");
        }
        return n.replace(o, r);
      }
      function _typeof(t) {
        return (_typeof =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" === typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      var o =
          ("undefined" !== typeof globalThis && globalThis) ||
          ("undefined" !== typeof self && self) ||
          ("undefined" !== typeof o && o),
        n = {
          searchParams: "URLSearchParams" in o,
          iterable: "Symbol" in o && "iterator" in Symbol,
          blob:
            "FileReader" in o &&
            "Blob" in o &&
            (function () {
              try {
                return (new Blob(), !0);
              } catch (t) {
                return !1;
              }
            })(),
          formData: "FormData" in o,
          arrayBuffer: "ArrayBuffer" in o,
        };
      if (n.arrayBuffer)
        var i = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]",
          ],
          s =
            ArrayBuffer.isView ||
            function (t) {
              return t && i.indexOf(Object.prototype.toString.call(t)) > -1;
            };
      function normalizeName(t) {
        if (
          ("string" !== typeof t && (t = String(t)),
          /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(t) || "" === t)
        )
          throw new TypeError("Invalid character in header field name");
        return t.toLowerCase();
      }
      function normalizeValue(t) {
        return ("string" !== typeof t && (t = String(t)), t);
      }
      function iteratorFor(t) {
        var e = {
          next: function () {
            var e = t.shift();
            return { done: void 0 === e, value: e };
          },
        };
        return (
          n.iterable &&
            (e[Symbol.iterator] = function () {
              return e;
            }),
          e
        );
      }
      function Headers(t) {
        ((this.map = {}),
          t instanceof Headers
            ? t.forEach(function (t, e) {
                this.append(e, t);
              }, this)
            : Array.isArray(t)
              ? t.forEach(function (t) {
                  this.append(t[0], t[1]);
                }, this)
              : t &&
                Object.getOwnPropertyNames(t).forEach(function (e) {
                  this.append(e, t[e]);
                }, this));
      }
      function consumed(t) {
        if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
        t.bodyUsed = !0;
      }
      function fileReaderReady(t) {
        return new Promise(function (e, r) {
          ((t.onload = function () {
            e(t.result);
          }),
            (t.onerror = function () {
              r(t.error);
            }));
        });
      }
      function readBlobAsArrayBuffer(t) {
        var e = new FileReader(),
          r = fileReaderReady(e);
        return (e.readAsArrayBuffer(t), r);
      }
      function bufferClone(t) {
        if (t.slice) return t.slice(0);
        var e = new Uint8Array(t.byteLength);
        return (e.set(new Uint8Array(t)), e.buffer);
      }
      function Body() {
        return (
          (this.bodyUsed = !1),
          (this._initBody = function (t) {
            var e;
            ((this.bodyUsed = this.bodyUsed),
              (this._bodyInit = t),
              t
                ? "string" === typeof t
                  ? (this._bodyText = t)
                  : n.blob && Blob.prototype.isPrototypeOf(t)
                    ? (this._bodyBlob = t)
                    : n.formData && FormData.prototype.isPrototypeOf(t)
                      ? (this._bodyFormData = t)
                      : n.searchParams &&
                          URLSearchParams.prototype.isPrototypeOf(t)
                        ? (this._bodyText = t.toString())
                        : n.arrayBuffer &&
                            n.blob &&
                            (e = t) &&
                            DataView.prototype.isPrototypeOf(e)
                          ? ((this._bodyArrayBuffer = bufferClone(t.buffer)),
                            (this._bodyInit = new Blob([
                              this._bodyArrayBuffer,
                            ])))
                          : n.arrayBuffer &&
                              (ArrayBuffer.prototype.isPrototypeOf(t) || s(t))
                            ? (this._bodyArrayBuffer = bufferClone(t))
                            : (this._bodyText = t =
                                Object.prototype.toString.call(t))
                : (this._bodyText = ""),
              this.headers.get("content-type") ||
                ("string" === typeof t
                  ? this.headers.set("content-type", "text/plain;charset=UTF-8")
                  : this._bodyBlob && this._bodyBlob.type
                    ? this.headers.set("content-type", this._bodyBlob.type)
                    : n.searchParams &&
                      URLSearchParams.prototype.isPrototypeOf(t) &&
                      this.headers.set(
                        "content-type",
                        "application/x-www-form-urlencoded;charset=UTF-8",
                      )));
          }),
          n.blob &&
            ((this.blob = function () {
              var t = consumed(this);
              if (t) return t;
              if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
              if (this._bodyArrayBuffer)
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              if (this._bodyFormData)
                throw new Error("could not read FormData body as blob");
              return Promise.resolve(new Blob([this._bodyText]));
            }),
            (this.arrayBuffer = function () {
              if (this._bodyArrayBuffer) {
                var t = consumed(this);
                return (
                  t ||
                  (ArrayBuffer.isView(this._bodyArrayBuffer)
                    ? Promise.resolve(
                        this._bodyArrayBuffer.buffer.slice(
                          this._bodyArrayBuffer.byteOffset,
                          this._bodyArrayBuffer.byteOffset +
                            this._bodyArrayBuffer.byteLength,
                        ),
                      )
                    : Promise.resolve(this._bodyArrayBuffer))
                );
              }
              return this.blob().then(readBlobAsArrayBuffer);
            })),
          (this.text = function () {
            var t = consumed(this);
            if (t) return t;
            if (this._bodyBlob)
              return (function (t) {
                var e = new FileReader(),
                  r = fileReaderReady(e);
                return (e.readAsText(t), r);
              })(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(
                (function (t) {
                  for (
                    var e = new Uint8Array(t), r = new Array(e.length), a = 0;
                    a < e.length;
                    a++
                  )
                    r[a] = String.fromCharCode(e[a]);
                  return r.join("");
                })(this._bodyArrayBuffer),
              );
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }),
          n.formData &&
            (this.formData = function () {
              return this.text().then(decode);
            }),
          (this.json = function () {
            return this.text().then(JSON.parse);
          }),
          this
        );
      }
      ((Headers.prototype.append = function (t, e) {
        ((t = normalizeName(t)), (e = normalizeValue(e)));
        var r = this.map[t];
        this.map[t] = r ? r + ", " + e : e;
      }),
        (Headers.prototype.delete = function (t) {
          delete this.map[normalizeName(t)];
        }),
        (Headers.prototype.get = function (t) {
          return ((t = normalizeName(t)), this.has(t) ? this.map[t] : null);
        }),
        (Headers.prototype.has = function (t) {
          return this.map.hasOwnProperty(normalizeName(t));
        }),
        (Headers.prototype.set = function (t, e) {
          this.map[normalizeName(t)] = normalizeValue(e);
        }),
        (Headers.prototype.forEach = function (t, e) {
          for (var r in this.map)
            this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this);
        }),
        (Headers.prototype.keys = function () {
          var t = [];
          return (
            this.forEach(function (e, r) {
              t.push(r);
            }),
            iteratorFor(t)
          );
        }),
        (Headers.prototype.values = function () {
          var t = [];
          return (
            this.forEach(function (e) {
              t.push(e);
            }),
            iteratorFor(t)
          );
        }),
        (Headers.prototype.entries = function () {
          var t = [];
          return (
            this.forEach(function (e, r) {
              t.push([r, e]);
            }),
            iteratorFor(t)
          );
        }),
        n.iterable &&
          (Headers.prototype[Symbol.iterator] = Headers.prototype.entries));
      var c = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function Request(t, e) {
        if (!(this instanceof Request))
          throw new TypeError(
            'Please use the "new" operator, this DOM object constructor cannot be called as a function.',
          );
        var r = (e = e || {}).body;
        if (t instanceof Request) {
          if (t.bodyUsed) throw new TypeError("Already read");
          ((this.url = t.url),
            (this.credentials = t.credentials),
            e.headers || (this.headers = new Headers(t.headers)),
            (this.method = t.method),
            (this.mode = t.mode),
            (this.signal = t.signal),
            r || null == t._bodyInit || ((r = t._bodyInit), (t.bodyUsed = !0)));
        } else this.url = String(t);
        if (
          ((this.credentials =
            e.credentials || this.credentials || "same-origin"),
          (!e.headers && this.headers) ||
            (this.headers = new Headers(e.headers)),
          (this.method = (function (t) {
            var e = t.toUpperCase();
            return c.indexOf(e) > -1 ? e : t;
          })(e.method || this.method || "GET")),
          (this.mode = e.mode || this.mode || null),
          (this.signal = e.signal || this.signal),
          (this.referrer = null),
          ("GET" === this.method || "HEAD" === this.method) && r)
        )
          throw new TypeError("Body not allowed for GET or HEAD requests");
        if (
          (this._initBody(r),
          ("GET" === this.method || "HEAD" === this.method) &&
            ("no-store" === e.cache || "no-cache" === e.cache))
        ) {
          var a = /([?&])_=[^&]*/;
          if (a.test(this.url))
            this.url = this.url.replace(a, "$1_=" + new Date().getTime());
          else {
            this.url +=
              (/\?/.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
          }
        }
      }
      function decode(t) {
        var e = new FormData();
        return (
          t
            .trim()
            .split("&")
            .forEach(function (t) {
              if (t) {
                var r = t.split("="),
                  a = r.shift().replace(/\+/g, " "),
                  o = r.join("=").replace(/\+/g, " ");
                e.append(decodeURIComponent(a), decodeURIComponent(o));
              }
            }),
          e
        );
      }
      function parseHeaders(t) {
        var e = new Headers();
        return (
          t
            .replace(/\r?\n[\t ]+/g, " ")
            .split(/\r?\n/)
            .forEach(function (t) {
              var r = t.split(":"),
                a = r.shift().trim();
              if (a) {
                var o = r.join(":").trim();
                e.append(a, o);
              }
            }),
          e
        );
      }
      function Response(t, e) {
        if (!(this instanceof Response))
          throw new TypeError(
            'Please use the "new" operator, this DOM object constructor cannot be called as a function.',
          );
        (e || (e = {}),
          (this.type = "default"),
          (this.status = void 0 === e.status ? 200 : e.status),
          (this.ok = this.status >= 200 && this.status < 300),
          (this.statusText = "statusText" in e ? e.statusText : ""),
          (this.headers = new Headers(e.headers)),
          (this.url = e.url || ""),
          this._initBody(t));
      }
      ((Request.prototype.clone = function () {
        return new Request(this, { body: this._bodyInit });
      }),
        Body.call(Request.prototype),
        Body.call(Response.prototype),
        (Response.prototype.clone = function () {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url,
          });
        }),
        (Response.error = function () {
          var t = new Response(null, { status: 0, statusText: "" });
          return ((t.type = "error"), t);
        }));
      var l = [301, 302, 303, 307, 308];
      Response.redirect = function (t, e) {
        if (-1 === l.indexOf(e)) throw new RangeError("Invalid status code");
        return new Response(null, { status: e, headers: { location: t } });
      };
      var u = o.DOMException;
      try {
        new u();
      } catch (y) {
        (((u = function (t, e) {
          ((this.message = t), (this.name = e));
          var r = Error(t);
          this.stack = r.stack;
        }).prototype = Object.create(Error.prototype)),
          (u.prototype.constructor = u));
      }
      function fetch(t, e) {
        return new Promise(function (r, a) {
          var i = new Request(t, e);
          if (i.signal && i.signal.aborted)
            return a(new u("Aborted", "AbortError"));
          var s = new XMLHttpRequest();
          function abortXhr() {
            s.abort();
          }
          ((s.onload = function () {
            var t = {
              status: s.status,
              statusText: s.statusText,
              headers: parseHeaders(s.getAllResponseHeaders() || ""),
            };
            t.url =
              "responseURL" in s
                ? s.responseURL
                : t.headers.get("X-Request-URL");
            var e = "response" in s ? s.response : s.responseText;
            setTimeout(function () {
              r(new Response(e, t));
            }, 0);
          }),
            (s.onerror = function () {
              setTimeout(function () {
                a(new TypeError("Network request failed"));
              }, 0);
            }),
            (s.ontimeout = function () {
              setTimeout(function () {
                a(new TypeError("Network request failed"));
              }, 0);
            }),
            (s.onabort = function () {
              setTimeout(function () {
                a(new u("Aborted", "AbortError"));
              }, 0);
            }),
            s.open(
              i.method,
              (function (t) {
                try {
                  return "" === t && o.location.href ? o.location.href : t;
                } catch (e) {
                  return t;
                }
              })(i.url),
              !0,
            ),
            "include" === i.credentials
              ? (s.withCredentials = !0)
              : "omit" === i.credentials && (s.withCredentials = !1),
            "responseType" in s &&
              (n.blob
                ? (s.responseType = "blob")
                : n.arrayBuffer &&
                  i.headers.get("Content-Type") &&
                  -1 !==
                    i.headers
                      .get("Content-Type")
                      .indexOf("application/octet-stream") &&
                  (s.responseType = "arraybuffer")),
            !e ||
            "object" !== _typeof(e.headers) ||
            e.headers instanceof Headers
              ? i.headers.forEach(function (t, e) {
                  s.setRequestHeader(e, t);
                })
              : Object.getOwnPropertyNames(e.headers).forEach(function (t) {
                  s.setRequestHeader(t, normalizeValue(e.headers[t]));
                }),
            i.signal &&
              (i.signal.addEventListener("abort", abortXhr),
              (s.onreadystatechange = function () {
                4 === s.readyState &&
                  i.signal.removeEventListener("abort", abortXhr);
              })),
            s.send("undefined" === typeof i._bodyInit ? null : i._bodyInit));
        });
      }
      ((fetch.polyfill = !0),
        o.fetch ||
          ((o.fetch = fetch),
          (o.Headers = Headers),
          (o.Request = Request),
          (o.Response = Response)));
      var d = r(0),
        f = r.n(d);
      function _defineProperties(t, e) {
        for (var r = 0; r < e.length; r++) {
          var a = e[r];
          ((a.enumerable = a.enumerable || !1),
            (a.configurable = !0),
            "value" in a && (a.writable = !0),
            Object.defineProperty(t, a.key, a));
        }
      }
      var h = (function () {
        function GoCart(t) {
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, GoCart);
          ((this.defaults = Object.assign(
            {},
            {
              atcCrossSellProduct: null,
              cartModalatcButton: ".js-go-cart-modal-atc-button",
              cartModalFail: ".js-go-cart-modal-fail",
              cartModalFailClose: ".js-go-cart-modal-fail-close",
              cartModal: ".js-go-cart-modal",
              cartModalClose: ".js-go-cart-modal-close",
              cartModalContent: ".js-go-cart-modal-content",
              cartModalViewCartButton: ".js-go-cart-modal-view-cart-button",
              cartDrawer: ".js-go-cart-drawer",
              cartDrawerContent: ".js-go-cart-drawer-content",
              cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
              cartDrawerFreeshipping: ".cart_",
              cartDrawerFooter: ".js-go-cart-drawer-footer",
              cartDrawerClose: ".js-go-cart-drawer-close",
              cartMiniCart: ".js-go-cart-mini-cart",
              cartMiniCartContent: ".js-go-cart-mini-cart-content",
              cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
              cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
              cartTrigger: ".js-go-cart-trigger",
              cartOverlay: ".js-go-cart-overlay",
              cartCount: ".js-go-cart-counter",
              addToCart: ".js-go-cart-add-to-cart",
              customAddToCart: ".js-go-cart-custom-add-to-cart",
              removeFromCart: ".js-go-cart-remove-from-cart",
              removeFromCartNoDot: "js-go-cart-remove-from-cart",
              itemQuantity: ".js-go-cart-quantity",
              itemQuantityPlus: ".js-go-cart-quantity-plus",
              itemQuantityMinus: ".js-go-cart-quantity-minus",
              cartMode: "drawer",
              drawerDirection: "right",
              displayModal: !1,
              moneyFormat: "${{amount}}",
              labelAddedToCart: "was added to your cart.",
              labelCartIsEmpty: "Your Cart is currently empty!",
              labelQuantity: "Quantity:",
              labelRemove: "Remove",
            },
            t,
          )),
            (this.atcCrossSellProduct = this.defaults.atcCrossSellProduct),
            (this.cartModalatcButton = document.querySelector(
              this.defaults.cartModalatcButton,
            )),
            (this.cartModalFail = document.querySelector(
              this.defaults.cartModalFail,
            )),
            (this.cartModalFailClose = document.querySelector(
              this.defaults.cartModalFailClose,
            )),
            (this.cartModal = document.querySelector(this.defaults.cartModal)),
            (this.cartModalClose = document.querySelectorAll(
              this.defaults.cartModalClose,
            )),
            (this.cartModalContent = document.querySelector(
              this.defaults.cartModalContent,
            )),
            (this.cartModalViewCartButton = document.querySelector(
              this.defaults.cartModalViewCartButton,
            )),
            (this.cartDrawer = document.querySelector(
              this.defaults.cartDrawer,
            )),
            (this.cartDrawerContent = document.querySelector(
              this.defaults.cartDrawerContent,
            )),
            (this.cartDrawerSubTotal = document.querySelector(
              this.defaults.cartDrawerSubTotal,
            )),
            (this.cartDrawerFooter = document.querySelector(
              this.defaults.cartDrawerFooter,
            )),
            (this.cartDrawerClose = document.querySelector(
              this.defaults.cartDrawerClose,
            )),
            (this.cartMiniCart = document.querySelector(
              this.defaults.cartMiniCart,
            )),
            (this.cartMiniCartContent = document.querySelector(
              this.defaults.cartMiniCartContent,
            )),
            (this.cartMiniCartSubTotal = document.querySelector(
              this.defaults.cartMiniCartSubTotal,
            )),
            (this.cartMiniCartFooter = document.querySelector(
              this.defaults.cartMiniCartFooter,
            )),
            (this.cartTrigger = document.querySelector(
              this.defaults.cartTrigger,
            )),
            (this.cartOverlay = document.querySelector(
              this.defaults.cartOverlay,
            )),
            (this.cartCount = document.querySelector(this.defaults.cartCount)),
            (this.addToCart = document.querySelectorAll(
              this.defaults.addToCart,
            )),
            (this.customAddToCart = document.querySelectorAll(
              this.defaults.customAddToCart,
            )),
            (this.removeFromCart = this.defaults.removeFromCart),
            (this.removeFromCartNoDot = this.defaults.removeFromCartNoDot),
            (this.itemQuantity = this.defaults.itemQuantity),
            (this.itemQuantityPlus = this.defaults.itemQuantityPlus),
            (this.itemQuantityMinus = this.defaults.itemQuantityMinus),
            (this.cartMode = this.defaults.cartMode),
            (this.drawerDirection = this.defaults.drawerDirection),
            (this.displayModal = this.defaults.displayModal),
            (this.moneyFormat = this.defaults.moneyFormat),
            (this.labelAddedToCart = this.defaults.labelAddedToCart),
            (this.labelCartIsEmpty = this.defaults.labelCartIsEmpty),
            (this.labelQuantity = this.defaults.labelQuantity),
            (this.labelRemove = this.defaults.labelRemove),
            this.init());
        }
        var t, e, r;
        return (
          (t = GoCart),
          (r = [
            {
              key: "removeItemAnimation",
              value: function (t) {
                t.classList.add("is-invisible");
              },
            },
          ]),
          (e = [
            {
              key: "init",
              value: function () {
                var t = this;
                (this.fetchCart(null, { silent: true }),
                  this.isDrawerMode && this.setDrawerDirection(),
                  document.addEventListener(
                    "click",
                    function (e) {
                      if (e.target.matches(t.defaults.addToCart)) {
                        e.preventDefault();
                        for (
                          var r = e.target.parentNode;
                          "form" !== r.tagName.toLowerCase();
                        )
                          r = r.parentNode;
                        var a = r.getAttribute("id");
                        $(".cart-upsells").show();
                        $(".go-cart-drawer__subtotal").show();

                        t.addItemToCart(a);
                      }
                    },
                    !1,
                  ),
                  this.cartTrigger.addEventListener("click", function () {
                    (t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(),
                      t.openCartOverlay());
                  }),
                  this.cartOverlay.addEventListener("click", function () {
                    (t.closeFailModal(),
                      t.closeCartModal(),
                      t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(),
                      t.closeCartOverlay());
                  }),
                  this.isDrawerMode &&
                    this.cartDrawerClose.addEventListener("click", function () {
                      (t.closeCartDrawer(), t.closeCartOverlay());
                    }),
                  this.displayModal &&
                    this.cartModalClose.forEach(function (e) {
                      e.addEventListener("click", function () {
                        (t.closeFailModal(),
                          t.closeCartModal(),
                          t.isDrawerMode
                            ? t.closeCartDrawer()
                            : t.closeMiniCart(),
                          t.closeCartOverlay());
                      });
                    }),
                  this.cartModalFailClose.addEventListener(
                    "click",
                    function () {
                      (t.closeFailModal(),
                        t.closeCartModal(),
                        t.isDrawerMode
                          ? t.closeCartDrawer()
                          : t.closeMiniCart(),
                        t.closeCartOverlay());
                    },
                  ));
                this.customAddToCart.forEach((button) => {
                  button.addEventListener("click", () =>
                    t.addToCartWithButton(button),
                  );
                });
              },
            },
            {
              key: "fetchCart",
              value: function (t, options) {
                options = options || {};
                var e = this;
                window
                  .fetch("/cart.js", {
                    credentials: "same-origin",
                    method: "GET",
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (r) {
                    // if (document.body.dataset.gamification == 'true') {
                    //     e.handleGamification(r);
                    //     e.handleAdditionalUpsell(r);
                    //     e.renameUpsellItems();
                    // }
                    const lipSoreId = 39540060586145;
                    const lipSoreProdId = 43788993462433;
                    const genitalDevice = 39551636111521;
                    const genitalDevicePro = 43790136508577;
                    const mouthDevice = 39553629192353;
                    const acneDevice = 41160293122209;
                    const travelCaseId = 39560493203617;
                    const nailClear = 44329942483105;
                    // BrightEyes: variant 52603484373360 — keep price $0 in Admin; checkout validation enforces gift rules.
                    const brightEyesId = 52603484373360;
                    const rewindMask = 43898921091233;
                    const rednessMask = 44000841040033;
                    const vibeActive1 = 51645580280176;
                    const vibeActive2 = 51645580312944;
                    const vibeActive3 = 51645580345712;

                    if (!document.querySelector("body").dataset.bogoTest) {
                      const productsIds = [
                        lipSoreId,
                        lipSoreProdId,
                        genitalDevice,
                        genitalDevicePro,
                        mouthDevice,
                        acneDevice,
                      ];
                      // e.handleFreegift(r, productsIds, travelCaseId);
                    } else {
                      const productsIds = [
                        genitalDevice,
                        genitalDevicePro,
                        mouthDevice,
                      ];
                      e.handleFreegift(r, productsIds, travelCaseId);
                      e.handleFreegift(r, [lipSoreId], lipSoreId);
                      e.handleFreegift(r, [acneDevice], acneDevice);
                      e.handleFreegift(r, [nailClear], nailClear);
                    }

                    return e.syncPromotionalFreeGifts(r).then(function (cart) {
                      return e.fetchHandler(cart, t);
                    });
                  })
                  .catch(function (t) {
                    if (!options.silent) {
                      e.ajaxRequestFail();
                    } else {
                      console.warn(
                        "[GoCart] Background cart fetch failed:",
                        t,
                      );
                    }
                  });
              },
            },
            {
              key: "addItemToCart",
              value: function (t) {
                var e = this,
                  r = document.querySelector("#".concat(t)),
                  a = f()(r, { hash: !0 });
                if (a.id == null) {
                  var val_ = $("#" + t)
                    .find(".product-form__controls-group")
                    .data("id");
                  a.id = val_;
                }
                window
                  .fetch("/cart/add.js", {
                    method: "POST",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(a),
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    return e.addItemToCartHandler(t);
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "addToCartWithButton",
              value: function (button) {
                var e = this;
                const variantId = button.getAttribute("data-variant-id");
                button.disabled = true;
                if (!variantId) return;
                const requestBody = {
                  items: [
                    {
                      id: variantId,
                      quantity: 1,
                    },
                  ],
                };
                window
                  .fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestBody),
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    setTimeout(() => {
                      button.disabled = false;
                    }, 1500);
                    return e.addItemToCartHandler(t);
                  })
                  .catch(function (t) {
                    button.disabled = false;
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "getBrightEyesValidationContext",
              value: function () {
                // qualifyingVariantIds must match the store cart validation app (BrightEyes rules).
                return {
                  brightEyesGiftVariantId: 52603484373360,
                  qualifyingVariantIds: [
                    39540060586145, 43788993462433, 39551636111521,
                    43790136508577, 39553629192353, 41160293122209,
                    43898921091233, 44000841040033, 51645580280176,
                    51645580312944, 51645580345712,
                    53829490934128, 53829496602992, 53829496439152,
                  ],
                };
              },
            },
            {
              key: "getGlpReboundGiftContext",
              value: function () {
                // Must match luminance-checkout-validation rebound-gifts-config.ts
                return {
                  systemVariantId: 53829490934128,
                  podStandardVariantId: 53829496602992,
                  maskStandardVariantId: 53829496439152,
                  podGiftVariantId: 53829496635760,
                  maskGiftVariantId: 53829496471920,
                  serumGiftVariantId: 53831026704752,
                  creamGiftVariantId: 53829496930672,
                };
              },
            },
            {
              key: "getPromoGiftSyncRules",
              value: function () {
                var ctx = this.getGlpReboundGiftContext();
                var brightEyesId = 52603484373360;
                return [
                  {
                    triggers:
                      this.getBrightEyesValidationContext()
                        .qualifyingVariantIds,
                    giftId: brightEyesId,
                  },
                  {
                    triggers: [
                      ctx.systemVariantId,
                      ctx.maskStandardVariantId,
                    ],
                    giftId: ctx.serumGiftVariantId,
                  },
                  {
                    triggers: [
                      ctx.systemVariantId,
                      ctx.podStandardVariantId,
                    ],
                    giftId: ctx.creamGiftVariantId,
                  },
                ];
              },
            },
            {
              key: "cartItemsAfterLineChange",
              value: function (cart, line1Based, newQuantity) {
                var items = [];
                for (var idx = 0; idx < cart.items.length; idx++) {
                  var item = cart.items[idx];
                  var line = idx + 1;
                  var qty = item.quantity;
                  if (line === line1Based) qty = newQuantity;
                  if (qty > 0) {
                    var simulated = Object.assign({}, item);
                    simulated.quantity = qty;
                    items.push(simulated);
                  }
                }
                return items;
              },
            },
            {
              key: "findAllPromoGiftLines",
              value: function (items, giftId) {
                var lines = [];
                for (var i = 0; i < items.length; i++) {
                  var item = items[i];
                  if (
                    Number(item.id) === Number(giftId) &&
                    item.properties &&
                    item.properties._free_gift === "free_gift"
                  ) {
                    lines.push(item);
                  }
                }
                return lines;
              },
            },
            {
              key: "getPromoGiftAdjustmentsBeforeChange",
              value: function (cart, line1Based, newQuantity, excludeLineKey) {
                var self = this;
                var simulated = self.cartItemsAfterLineChange(
                  cart,
                  line1Based,
                  newQuantity,
                );
                var keysToRemove = [];
                var qtyUpdates = [];
                var seen = {};

                self.getPromoGiftSyncRules().forEach(function (rule) {
                  var requiredQty = self.getPromoTriggerQty(
                    simulated,
                    rule.triggers,
                  );
                  var giftLines = self.findAllPromoGiftLines(
                    cart.items,
                    rule.giftId,
                  );
                  if (!giftLines.length) return;

                  var currentQty = 0;
                  giftLines.forEach(function (line) {
                    if (line.key !== excludeLineKey) {
                      currentQty += line.quantity;
                    }
                  });
                  if (currentQty === 0) return;

                  if (requiredQty === 0) {
                    giftLines.forEach(function (line) {
                      if (
                        line.key === excludeLineKey ||
                        seen[line.key]
                      ) {
                        return;
                      }
                      seen[line.key] = true;
                      keysToRemove.push(line.key);
                    });
                    return;
                  }

                  if (currentQty <= requiredQty) return;

                  var remaining = requiredQty;
                  giftLines.forEach(function (line, index) {
                    if (line.key === excludeLineKey || seen[line.key]) return;
                    seen[line.key] = true;
                    var nextQty =
                      index === giftLines.length - 1
                        ? remaining
                        : Math.min(line.quantity, remaining);
                    remaining -= nextQty;
                    if (line.quantity !== nextQty) {
                      qtyUpdates.push({ key: line.key, quantity: nextQty });
                    }
                  });
                });

                return { keysToRemove: keysToRemove, qtyUpdates: qtyUpdates };
              },
            },
            {
              key: "getPromoGiftKeysToStripBeforeChange",
              value: function (cart, line1Based, newQuantity, excludeLineKey) {
                return this.getPromoGiftAdjustmentsBeforeChange(
                  cart,
                  line1Based,
                  newQuantity,
                  excludeLineKey,
                ).keysToRemove;
              },
            },
            {
              key: "getPromoTriggerQty",
              value: function (items, triggerIds) {
                var sum = 0;
                for (var t = 0; t < triggerIds.length; t++) {
                  for (var i = 0; i < items.length; i++) {
                    if (
                      this.lineItemQualifiesBrightEyesTrigger(
                        items[i],
                        triggerIds[t],
                      )
                    ) {
                      sum += items[i].quantity;
                    }
                  }
                }
                return sum;
              },
            },
            {
              key: "hasAnyPromoTrigger",
              value: function (items, triggerIds) {
                return this.getPromoTriggerQty(items, triggerIds) > 0;
              },
            },
            {
              key: "findPromoGiftLine",
              value: function (items, giftId) {
                var lines = this.findAllPromoGiftLines(items, giftId);
                return lines.length ? lines[0] : null;
              },
            },
            {
              key: "isPromoFreeGiftLine",
              value: function (item) {
                return (
                  item.properties &&
                  item.properties._free_gift === "free_gift"
                );
              },
            },
            {
              key: "syncPromotionalFreeGifts",
              value: function (cart) {
                var self = this;
                if (self._promoFreeGiftSyncActive) {
                  return Promise.resolve(cart);
                }

                var rules = self.getPromoGiftSyncRules();

                var giftsToAdd = [];
                var giftQtyUpdates = [];
                var lineKeysToRemove = [];

                rules.forEach(function (rule) {
                  var requiredQty = self.getPromoTriggerQty(
                    cart.items,
                    rule.triggers,
                  );
                  var giftLine = self.findPromoGiftLine(cart.items, rule.giftId);
                  if (requiredQty > 0) {
                    if (!giftLine) {
                      giftsToAdd.push({
                        giftId: rule.giftId,
                        quantity: requiredQty,
                      });
                    } else if (giftLine.quantity !== requiredQty) {
                      giftQtyUpdates.push({
                        key: giftLine.key,
                        quantity: requiredQty,
                      });
                    }
                  } else if (giftLine) {
                    lineKeysToRemove.push(giftLine.key);
                  }
                });

                var glpCtx = self.getGlpReboundGiftContext();
                [glpCtx.podGiftVariantId, glpCtx.maskGiftVariantId].forEach(
                  function (giftId) {
                    var bundleGiftLine = self.findPromoGiftLine(
                      cart.items,
                      giftId,
                    );
                    if (
                      bundleGiftLine &&
                      lineKeysToRemove.indexOf(bundleGiftLine.key) === -1
                    ) {
                      lineKeysToRemove.push(bundleGiftLine.key);
                    }
                  },
                );

                if (
                  !giftsToAdd.length &&
                  !giftQtyUpdates.length &&
                  !lineKeysToRemove.length
                ) {
                  return Promise.resolve(cart);
                }

                self._promoFreeGiftSyncActive = true;

                var chain = Promise.resolve();

                lineKeysToRemove.forEach(function (key) {
                  chain = chain.then(function () {
                    return self.postCartChangeRaw(
                      { id: key, quantity: 0 },
                      { tolerate422: true },
                    );
                  });
                });

                giftQtyUpdates.forEach(function (update) {
                  chain = chain.then(function () {
                    return self.postCartChangeRaw(
                      { id: update.key, quantity: update.quantity },
                      { tolerate422: true },
                    );
                  });
                });

                if (giftsToAdd.length) {
                  chain = chain.then(function () {
                    return self.addPromotionalGiftItems(giftsToAdd);
                  });
                }

                return chain
                  .then(function () {
                    return window.fetch("/cart.js", {
                      credentials: "same-origin",
                    });
                  })
                  .then(function (res) {
                    return res.json();
                  })
                  .then(function (freshCart) {
                    self._promoFreeGiftSyncActive = false;
                    return freshCart;
                  })
                  .catch(function (err) {
                    self._promoFreeGiftSyncActive = false;
                    console.warn("[GoCart] Promo gift sync failed:", err);
                    return cart;
                  });
              },
            },
            {
              key: "getCartLineLabelsForProduct",
              value: function (productId) {
                var map = window.luminanceCartLineLabels;
                if (!map) return null;
                return map[String(productId)] || null;
              },
            },
            {
              key: "getGiftRetailCentsForLineItem",
              value: function (item) {
                if (
                  !item.properties ||
                  item.properties._free_gift !== "free_gift"
                ) {
                  return null;
                }
                var map = window.luminancePromoGiftRetailCents;
                if (!map) return null;
                var cents = map[String(item.id)];
                if (cents == null || cents === "") return null;
                return Number(cents);
              },
            },
            {
              key: "formatFreeGiftPriceHtml",
              value: function (item, freeGift) {
                if (!freeGift || item.line_price !== 0) {
                  return formatMoney(item.line_price, this.moneyFormat);
                }
                var retailCents = this.getGiftRetailCentsForLineItem(item);
                if (retailCents > 0) {
                  return "<s>".concat(
                    formatMoney(retailCents, this.moneyFormat),
                    "</s> Free",
                  );
                }
                if (item.original_price > 0) {
                  return "<s>".concat(
                    formatMoney(item.original_price, this.moneyFormat),
                    "</s> Free",
                  );
                }
                return "Free";
              },
            },
            {
              key: "addPromotionalGiftItems",
              value: function (giftItems) {
                var brightEyesId = 52603484373360;
                var glpItems = giftItems.filter(function (item) {
                  return Number(item.giftId) !== brightEyesId;
                });
                var brightEyesItem = giftItems.find(function (item) {
                  return Number(item.giftId) === brightEyesId;
                });

                function addBatch(batch) {
                  if (!batch.length) return Promise.resolve();
                  return window
                    .fetch("/cart/add.js", {
                      method: "POST",
                      credentials: "include",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        items: batch.map(function (item) {
                          return {
                            id: item.giftId,
                            quantity: item.quantity,
                            properties: { _free_gift: "free_gift" },
                          };
                        }),
                      }),
                    })
                    .then(function (res) {
                      return res.json();
                    })
                    .then(function (data) {
                      if (data.status === 422) {
                        console.warn(
                          "[promo gifts] add blocked:",
                          data.message || data.description,
                        );
                      }
                    });
                }

                return addBatch(glpItems).then(function () {
                  if (brightEyesItem) return addBatch([brightEyesItem]);
                });
              },
            },
            {
              key: "lineItemQualifiesBrightEyesTrigger",
              value: function (item, variantId) {
                if (Number(item.id) !== Number(variantId)) return false;
                var p = item.properties;
                if (p == null || typeof p !== "object") return true;
                if (p._free_gift === "free_gift") return false;
                return true;
              },
            },
            {
              key: "isCartLineBrightEyesTrigger",
              value: function (item, qualifyingVariantIds) {
                for (var i = 0; i < qualifyingVariantIds.length; i++) {
                  if (
                    this.lineItemQualifiesBrightEyesTrigger(
                      item,
                      qualifyingVariantIds[i],
                    )
                  )
                    return true;
                }
                return false;
              },
            },
            {
              key: "remainingBrightEyesTriggerQtyAfterChange",
              value: function (cart, line1Based, newQuantity) {
                var ctx = this.getBrightEyesValidationContext();
                var ids = ctx.qualifyingVariantIds;
                var sum = 0;
                for (var idx = 0; idx < cart.items.length; idx++) {
                  var item = cart.items[idx];
                  var line = idx + 1;
                  var q = item.quantity;
                  if (line === line1Based) q = newQuantity;
                  if (q > 0 && this.isCartLineBrightEyesTrigger(item, ids))
                    sum += q;
                }
                return sum;
              },
            },
            {
              key: "postCartBatchUpdateRaw",
              value: function (updates, options) {
                options = options || {};
                return window
                  .fetch("/cart/update.js", {
                    method: "POST",
                    credentials: "same-origin",
                    body: JSON.stringify({ updates: updates }),
                    headers: { "Content-Type": "application/json" },
                  })
                  .then(function (res) {
                    return res.json();
                  })
                  .then(function (data) {
                    if (data.status === 422) {
                      if (options.tolerate422) {
                        console.warn(
                          "[GoCart] Cart batch update blocked:",
                          data.message || data.description,
                        );
                        return data;
                      }
                      return Promise.reject(
                        new Error(
                          data.message ||
                            data.description ||
                            "Cart validation failed",
                        ),
                      );
                    }
                    return data;
                  });
              },
            },
            {
              key: "postCartChangeRaw",
              value: function (body, options) {
                options = options || {};
                return window
                  .fetch("/cart/change.js", {
                    method: "POST",
                    credentials: "same-origin",
                    body: JSON.stringify(body),
                    headers: { "Content-Type": "application/json" },
                  })
                  .then(function (res) {
                    return res.json();
                  })
                  .then(function (data) {
                    if (data.status === 422) {
                      if (options.tolerate422) {
                        console.warn(
                          "[GoCart] Cart change blocked during sync:",
                          data.message || data.description,
                        );
                        return data;
                      }
                      return Promise.reject(
                        new Error(
                          data.message ||
                            data.description ||
                            "Cart validation failed",
                        ),
                      );
                    }
                    return data;
                  });
              },
            },
            {
              key: "applyCartChangeWithBrightEyesOrdering",
              value: function (line1Based, newQuantity) {
                var self = this;
                return window
                  .fetch("/cart.js", { credentials: "same-origin" })
                  .then(function (r) {
                    return r.json();
                  })
                  .then(function (cart) {
                    var targetItem = cart.items[line1Based - 1];
                    if (!targetItem) {
                      return self.postCartChangeRaw({
                        quantity: newQuantity,
                        line: line1Based,
                      });
                    }

                    if (self.isPromoFreeGiftLine(targetItem)) {
                      return self.postCartChangeRaw({
                        id: targetItem.key,
                        quantity: newQuantity,
                      });
                    }

                    var adjustments = self.getPromoGiftAdjustmentsBeforeChange(
                      cart,
                      line1Based,
                      newQuantity,
                      targetItem.key,
                    );

                    var batchUpdates = {};
                    adjustments.qtyUpdates.forEach(function (update) {
                      batchUpdates[update.key] = update.quantity;
                    });
                    adjustments.keysToRemove.forEach(function (key) {
                      batchUpdates[key] = 0;
                    });
                    batchUpdates[targetItem.key] = newQuantity;

                    var hasGiftAdjustments =
                      adjustments.qtyUpdates.length ||
                      adjustments.keysToRemove.length;

                    if (hasGiftAdjustments) {
                      return self.postCartBatchUpdateRaw(batchUpdates);
                    }

                    return self.postCartChangeRaw({
                      id: targetItem.key,
                      quantity: newQuantity,
                    });
                  })
                  .then(function () {
                    return self.fetchCart();
                  })
                  .catch(function (t) {
                    throw (self.ajaxRequestFail(), t);
                  });
              },
            },
            {
              key: "removeItem",
              value: function (t) {
                this.applyCartChangeWithBrightEyesOrdering(Number(t), 0);
              },
            },
            {
              key: "changeItemQuantity",
              value: function (t, e) {
                this.applyCartChangeWithBrightEyesOrdering(Number(t), e);
              },
            },
            {
              key: "cartItemCount",
              value: function (t) {
                this.cartCount.innerHTML = t.item_count;
              },
            },
            {
              key: "fetchAndOpenCart",
              value: function () {
                var t = this;
                this.fetchCart(function () {
                  (t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(),
                    t.openCartOverlay());
                });
              },
            },
            {
              key: "fetchAndOpenModal",
              value: function (t) {
                var e = this;
                this.fetchCart(function () {
                  (e.renderCartModal(t),
                    e.openCartModal(),
                    e.openCartOverlay());
                });
              },
            },
            {
              key: "fetchHandler",
              value: function (t, e) {
                (this.cartItemCount(t),
                  this.isDrawerMode
                    ? 0 === t.item_count
                      ? (this.renderBlankCartDrawer(),
                        this.cartDrawerFooter.classList.add("is-invisible"))
                      : (this.renderDrawerCart(t),
                        this.cartDrawerFooter.classList.remove("is-invisible"),
                        "function" === typeof e && e(t))
                    : 0 === t.item_count
                      ? (this.renderBlankMiniCart(),
                        this.cartMiniCartFooter.classList.add("is-invisible"))
                      : (this.renderMiniCart(t),
                        this.cartMiniCartFooter.classList.remove(
                          "is-invisible",
                        ),
                        "function" === typeof e && e(t)));
              },
            },
            {
              key: "addItemToCartHandler",
              value: function (t) {
                return this.displayModal
                  ? this.fetchAndOpenModal(t)
                  : this.fetchAndOpenCart();
              },
            },
            {
              key: "ajaxRequestFail",
              value: function () {
                (this.openFailModal(), this.openCartOverlay());
              },
            },
            {
              key: "renderCartModal",
              value: function (t) {
                //this.clearCartModal();
                var e = t.variant_title;
                e = null === e ? "" : "(".concat(e, ")");
                var r =
                  '\n        <div class="go-cart-modal-item">\n            <div class="go-cart-item__image" style="background-image: url('
                    .concat(
                      t.image,
                      ');"></div>\n            <div class="go-cart-item__info">\n                <a href="',
                    )
                    .concat(t.url, '" class="go-cart-item__title">')
                    .concat(t.product_title, " ")
                    .concat(e, "</a> ")
                    .concat(
                      this.labelAddedToCart,
                      "\n            </div>\n        </div>\n      ",
                    );

                console.log("renderCarModal");
                var d = this;

                $(".js-go-cart-modal-view-cart-button").click(function () {
                  console.log("cartModalViewCartButton jClicked");
                  d.closeCartModal();
                  d.fetchAndOpenCart();
                });

                this.cartModalatcButton.addEventListener("click", function () {
                  console.log("cartModalatcButton Clicked");
                  var variantId = d.atcCrossSellProduct.variants[0].id;
                  fetch("/cart/add?id=" + variantId + "&quantity=1")
                    .then((response) => {
                      d.closeCartModal();
                      d.renameUpsellItems();
                      d.fetchAndOpenCart();
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                });
                //this.cartModalContent.innerHTML += r;
              },
            },
            {
              key: "renderDrawerCart",
              value: function (t) {
                var e = this;
                (this.clearCartDrawer(),
                  t.items.forEach(function (t, r) {
                    var a = t.variant_title;
                    null === a && (a = "");
                    var string_ = t.product_title;
                    var title_ = string_;
                    if (title_.indexOf("Treatment Device ") >= 0) {
                      title_ = title_.replace("Treatment Device ", "");
                    }
                    if (title_.indexOf("Lip Sore") >= 0)
                      title_ = title_.replace(
                        "Lip Sore",
                        "Essential Lip Sore Device",
                      );
                    else if (title_.indexOf("Mouth Sore") >= 0)
                      title_ = title_.replace("Mouth Sore", "Mouth Device");
                    else if (title_.indexOf("Genital") >= 0)
                      title_ = title_ + " Device";
                    if (title_.indexOf("Extra Fiber Optic Tip") >= 0) {
                      title_ = title_.replace(
                        "Extra Fiber Optic Tip",
                        "Fiber Optic Tip",
                      );
                    }
                    if (string_.indexOf("Luminance RED Two") >= 0) {
                      title_ = title_.replace(
                        "Luminance RED Two",
                        "Acne Device",
                      );
                    }
                    // Product Mask's
                    if (string_.indexOf("Rosacea") >= 0) {
                      title_ = title_.replace("Rejuvenate", "Rosacea Mask");
                    }
                    if (string_.indexOf("Precision") >= 0) {
                      title_ = title_.replace(
                        "Spotless",
                        "Hyperpigmentation Mask",
                      );
                    }
                    if (string_.indexOf("Eczema") >= 0) {
                      title_ = title_.replace("Rejuvenate", "Eczema Mask");
                    }
                    if (string_.indexOf("Age") >= 0) {
                      title_ = title_.replace("Rejuvenate", "Age Rewind Mask");
                    }
                    if (string_.indexOf("Acne") >= 0) {
                      title_ = title_.replace("Spotless", "Acne Mask");
                    }
                    // End Product Mask's

                    if (string_ === "Vibe - Active Infusion Facial System") {
                      title_ = "Vibe Facial System";
                    }
                    if (
                      string_ === "Vibe - Essential Infusion Gem Collection"
                    ) {
                      title_ = "Facial Refills - Gem Collection";
                    }
                    if (
                      string_ ===
                      "Lip Sore Treatment Device - Pro - Luminance RED"
                    )
                      title_ = "Pro Lip Sore Device";
                    let freeGift = false;
                    if (t.properties && t.properties._free_gift)
                      freeGift = true;

                    /* changing upsell titles */
                    switch (title_) {
                      case "Luminance Medical Essential Cleaning Kit":
                        title_ = "Essential Cleaning Kit";
                        break;
                      case "Extra Fiber Optic Tip - The Luminance RED":
                        title_ = "Extra Fiber Optic Tip";
                        break;
                      case "Activating Topical System for the Lip Sore Device":
                        title_ = "Lip Topical System";
                        break;
                      case "Activating Topical System for the Acne Device":
                        title_ = "Acne Topical System";
                        break;
                      case "Activating Topical System for the Genital Device":
                        title_ = "Genital Topical System";
                        break;
                    }
                    /* END changing upsell titles */
                    let haveSubTitle = false;
                    let subtitleText = "";
                    if (
                      t.product_title === "Vibe - Active Infusion Facial System"
                    ) {
                      subtitleText =
                        "<span style='display: block;font-size: 12px;'>You're saving 13%</span>";
                    }

                    if (
                      t.product_title ===
                      "Vibe - Essential Infusion Gem Collection"
                    ) {
                      subtitleText =
                        "<span style='display: block;font-size: 12px;'>You're saving 13%</span>";
                    }

                    if (
                      t.product_title.includes("Vibe") &&
                      !t.selling_plan_allocation
                    ) {
                      subtitleText =
                        "<span style='display: block;font-size: 12px;'>One time purchase</span>";
                    }

                    if (
                      t.product_id === 14624177881456 ||
                      t.product_id === 14623857803632
                    ) {
                      const discount = document.querySelector(
                        `details.PDM-variant--esthetical summary[data-variant-id='${t.variant_id}'] .PDM-variant__item-savings`,
                      );

                      if (discount) {
                        const discountValue = parseInt(
                          discount.textContent
                            .match(/\d[\d,]*/)[0]
                            .replace(/,/g, ""),
                        );
                        subtitleText = `<span style='display: block;font-size: 12px;'>You're saving $${discountValue}</span>`;
                      }
                    }

                    var cartLineLabels = e.getCartLineLabelsForProduct(
                      t.product_id,
                    );
                    if (cartLineLabels && cartLineLabels.title) {
                      title_ = cartLineLabels.title;
                    }
                    var cartVariantLine = "The Luminance RED";
                    if (cartLineLabels && cartLineLabels.description) {
                      cartVariantLine = cartLineLabels.description;
                    }

                    var o = `
                                            <div class="go-cart-item__single" data-line="${Number(
                                              r + 1,
                                            )}">
                                                <div class="go-cart-item__info-wrapper">
                                                    <div class="go-cart-item__image" style="background-image: url(${
                                                      t.image
                                                    });"></div>
                                                    <div class="go-cart-item__info">
                                                        <a href="${
                                                          t.url
                                                        }" class="go-cart-item__title">${title_} </a>
                                                        ${
                                                          t.product_id ===
                                                          14910014488944
                                                            ? ""
                                                            : `
                                                        <div class="go-cart-item__variant">
                                                            ${cartVariantLine}
                                                            ${subtitleText}
                                                        </div>
                                                        `
                                                        }
                                                        
                                                        ${
                                                          t.id ==
                                                            39560493203617 ||
                                                          !freeGift
                                                            ? `
                                                        <div class="go-cart-item__quantity">
                                                            <span class="go-cart-item__quantity-label">${e.labelQuantity} </span>
                                                            <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                                                            <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${t.quantity}" disabled>
                                                            <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
                                                        </div>
                                                        `
                                                            : ""
                                                        }
                                                        

                                                    </div>
                                                </div>
                                                <div class="go-cart-item__price">${e.formatFreeGiftPriceHtml(
                                                  t,
                                                  freeGift,
                                                )}</div>
                                                <a class="go-cart-item__remove ${
                                                  e.removeFromCartNoDot
                                                }">${e.labelRemove}</a>
                                            </div>
                                        `;
                    e.cartDrawerContent.innerHTML += o;
                  }),
                  (this.cartDrawerSubTotal.innerHTML = formatMoney(
                    t.total_price,
                    this.moneyFormat,
                  )),
                  this.cartDrawerSubTotal.parentNode.classList.remove(
                    "is-invisible",
                  ),
                  document
                    .querySelectorAll(this.removeFromCart)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        GoCart.removeItemAnimation(t.parentNode);
                        var r = t.parentNode.getAttribute("data-line");
                        e.removeItem(r);
                      });
                    }),
                  document
                    .querySelectorAll(this.itemQuantityPlus)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        var r =
                            t.parentNode.parentNode.parentNode.parentNode.getAttribute(
                              "data-line",
                            ),
                          a =
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value,
                            ) + 1;
                        e.changeItemQuantity(r, a);
                      });
                    }),
                  document
                    .querySelectorAll(this.itemQuantityMinus)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        var r =
                            t.parentNode.parentNode.parentNode.parentNode.getAttribute(
                              "data-line",
                            ),
                          a =
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value,
                            ) - 1;
                        (e.changeItemQuantity(r, a),
                          0 ===
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value -
                                1,
                            ) &&
                            GoCart.removeItemAnimation(
                              t.parentNode.parentNode.parentNode.parentNode,
                            ));
                      });
                    }));
              },
            },
            {
              key: "renderMiniCart",
              value: function (t) {
                var e = this;
                (this.clearMiniCart(),
                  t.items.forEach(function (t, r) {
                    var a = t.variant_title;
                    null === a && (a = "");
                    var o =
                      '\n        <div class="go-cart-item__single" data-line="'
                        .concat(
                          Number(r + 1),
                          '">\n            <div class="go-cart-item__info-wrapper">\n                <div class="go-cart-item__image" style="background-image: url(',
                        )
                        .concat(
                          t.image,
                          ');"></div>\n                <div class="go-cart-item__info">\n                    <a href="',
                        )
                        .concat(t.url, '" class="go-cart-item__title">')
                        .concat(
                          t.product_title,
                          '</a>\n                    <div class="go-cart-item__variant">',
                        )
                        .concat(
                          a,
                          '</div>\n                    <div class="go-cart-item__quantity">\n                        <span class="go-cart-item__quantity-label">',
                        )
                        .concat(
                          e.labelQuantity,
                          ' </span>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>\n                        <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="',
                        )
                        .concat(
                          t.quantity,
                          '" disabled>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>\n                    </div>\n                </div>\n            </div>\n            <div class="go-cart-item__price">',
                        )
                        .concat(
                          formatMoney(t.line_price, e.moneyFormat),
                          '</div>\n            <a class="go-cart-item__remove ',
                        )
                        .concat(e.removeFromCartNoDot, '">')
                        .concat(e.labelRemove, "</a>\n        </div>\n      ");
                    e.cartMiniCartContent.innerHTML += o;
                  }),
                  (this.cartMiniCartSubTotal.innerHTML = formatMoney(
                    t.total_price,
                    this.moneyFormat,
                  )),
                  this.cartMiniCartSubTotal.parentNode.classList.remove(
                    "is-invisible",
                  ),
                  document
                    .querySelectorAll(this.removeFromCart)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        GoCart.removeItemAnimation(t.parentNode);
                        var r = t.parentNode.getAttribute("data-line");
                        e.removeItem(r);
                      });
                    }),
                  document
                    .querySelectorAll(this.itemQuantityPlus)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        var r =
                            t.parentNode.parentNode.parentNode.parentNode.getAttribute(
                              "data-line",
                            ),
                          a =
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value,
                            ) + 1;
                        e.changeItemQuantity(r, a);
                      });
                    }),
                  document
                    .querySelectorAll(this.itemQuantityMinus)
                    .forEach(function (t) {
                      t.addEventListener("click", function () {
                        var r =
                            t.parentNode.parentNode.parentNode.parentNode.getAttribute(
                              "data-line",
                            ),
                          a =
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value,
                            ) - 1;
                        (e.changeItemQuantity(r, a),
                          0 ===
                            Number(
                              t.parentNode.querySelector(e.itemQuantity).value -
                                1,
                            ) &&
                            GoCart.removeItemAnimation(
                              t.parentNode.parentNode.parentNode.parentNode,
                            ));
                      });
                    }));
              },
            },
            {
              key: "renderBlankCartDrawer",
              value: function () {
                $(".cart-upsells").hide();
                $(".go-cart-drawer__subtotal").hide();
                (this.cartDrawerSubTotal.parentNode.classList.add(
                  "is-invisible",
                ),
                  this.clearCartDrawer(),
                  (this.cartDrawerContent.innerHTML =
                    '<div class="go-cart__empty">'.concat(
                      this.labelCartIsEmpty,
                      "</div>",
                    )));
                $(
                  '<a href="/" class="btn btn--primary shop_now_">Shop Now</a>',
                ).insertAfter(".go-cart__empty");
              },
            },
            {
              key: "renderBlankMiniCart",
              value: function () {
                (this.cartMiniCartSubTotal.parentNode.classList.add(
                  "is-invisible",
                ),
                  this.clearMiniCart(),
                  (this.cartMiniCartContent.innerHTML =
                    '<div class="go-cart__empty">'.concat(
                      this.labelCartIsEmpty,
                      "</div>",
                    )));
              },
            },
            {
              key: "clearCartDrawer",
              value: function () {
                this.cartDrawerContent.innerHTML = "";
              },
            },
            {
              key: "clearMiniCart",
              value: function () {
                this.cartMiniCartContent.innerHTML = "";
              },
            },
            {
              key: "clearCartModal",
              value: function () {
                this.cartModalContent.innerHTML = "";
              },
            },
            {
              key: "openCartDrawer",
              value: function () {
                this.cartDrawer.classList.add("is-open");
              },
            },
            {
              key: "closeCartDrawer",
              value: function () {
                this.cartDrawer.classList.remove("is-open");
              },
            },
            {
              key: "openMiniCart",
              value: function () {
                this.cartMiniCart.classList.add("is-open");
              },
            },
            {
              key: "closeMiniCart",
              value: function () {
                this.cartMiniCart.classList.remove("is-open");
              },
            },
            {
              key: "openFailModal",
              value: function () {
                this.cartModalFail.classList.add("is-open");
              },
            },
            {
              key: "closeFailModal",
              value: function () {
                this.cartModalFail.classList.remove("is-open");
              },
            },
            {
              key: "openCartModal",
              value: function () {
                this.cartModal.classList.add("is-open");
              },
            },
            {
              key: "closeCartModal",
              value: function () {
                console.log("closeCartModal");
                this.cartModal.classList.remove("is-open");
              },
            },
            {
              key: "openCartOverlay",
              value: function () {
                this.cartOverlay.classList.add("is-open");
              },
            },
            {
              key: "closeCartOverlay",
              value: function () {
                this.cartOverlay.classList.remove("is-open");
              },
            },
            {
              key: "setDrawerDirection",
              value: function () {
                this.cartDrawer.classList.add(
                  "go-cart__drawer--".concat(this.drawerDirection),
                );
              },
            },
            {
              key: "isDrawerMode",
              get: function () {
                return "drawer" === this.cartMode;
              },
            },
            {
              key: "handleGamification",
              value: function (data) {
                var e = this;
                const cartGamification =
                  document.querySelector(".cart-gamification");
                const message = cartGamification.querySelector(
                  ".gamification-message",
                );
                const progressFill =
                  cartGamification.querySelector(".progress-fill");
                const progressBar =
                  cartGamification.querySelector(".progress-bar");

                const freeShippingThreshold =
                  Number(cartGamification.dataset.freeShippingThreshold) * 100;
                const freeShippingText =
                  cartGamification.dataset.freeShippingText;

                const freeGiftThreshold =
                  Number(cartGamification.dataset.freeGiftThreshold) * 100;
                const freeGiftText = cartGamification.dataset.freeGiftText;

                const freeGiftId = Number(cartGamification.dataset.freeGiftId);
                const freeGiftName = cartGamification.dataset.freeGiftName;

                let totalPrice = data.total_price;
                const cartItems = data.items;

                if (totalPrice === 0 || data.items.length === 0) {
                  cartGamification.classList.add("hidden");
                  progressBar.classList.remove("complete");
                  return;
                } else {
                  cartGamification.classList.remove("hidden");
                }

                const freeItem = cartItems.find((item, index) => {
                  return (
                    item.id === freeGiftId &&
                    item.properties._free_gift === "free_gift"
                  );
                });
                const freeGiftLine = cartItems.indexOf(freeItem) + 1;

                // Remove price of the free gift if discount is not applied
                if (freeItem) totalPrice = totalPrice - freeItem.final_price;

                if (totalPrice < freeShippingThreshold) {
                  message.innerHTML = `You are ${formatMoney(
                    freeShippingThreshold - totalPrice,
                    e.moneyFormat,
                  )} Away From ${freeShippingText}`;
                  if (freeItem) e.removeItem(freeGiftLine);
                  progressFill.style.width = "25%";
                  progressBar.classList.remove("complete");
                }
                if (
                  totalPrice >= freeShippingThreshold &&
                  totalPrice < freeGiftThreshold &&
                  totalPrice > 0
                ) {
                  message.innerHTML = `You are ${formatMoney(
                    freeGiftThreshold - totalPrice,
                    e.moneyFormat,
                  )} Away From ${freeGiftText}`;
                  if (freeItem) e.removeItem(freeGiftLine);
                  progressFill.style.width = "75%";
                  progressBar.classList.remove("complete");
                }
                if (totalPrice >= freeGiftThreshold) {
                  message.innerHTML = `You've Earned It! ${freeGiftText} Now Included.`;
                  if (!freeItem) e.addFreeGift(freeGiftId);
                  if (freeItem && freeItem.quantity > 1)
                    e.removeItem(freeGiftLine); // Control if and additional free gift is added on the front
                  progressFill.style.width = "100%";
                  progressBar.classList.add("complete");
                }
              },
            },
            {
              key: "handleFreegift",
              value: function (data, productsIds, freeGiftId) {
                var e = this;
                const cartItems = data.items;

                function qualifiesAsTriggerProduct(item, variantId) {
                  if (item.id !== variantId) return false;
                  var p = item.properties;
                  if (p == null || typeof p !== "object") return true;
                  if (p._free_gift === "free_gift") return false;
                  return true;
                }

                let productFound = null;
                for (let i = 0; i < productsIds.length; i++) {
                  productFound = cartItems.some((item) =>
                    qualifiesAsTriggerProduct(item, productsIds[i]),
                  );
                  if (productFound) break;
                }

                const freeItem = cartItems.find((item) => {
                  if (!item.properties || !item.properties._free_gift)
                    return false;
                  return (
                    item.id === freeGiftId &&
                    item.properties._free_gift === "free_gift"
                  );
                });
                if (productFound && !freeItem) {
                  e.addFreeGift(freeGiftId);
                }
                if (!productFound && freeItem) {
                  const freeGiftLine = cartItems.indexOf(freeItem) + 1;
                  e.removeItem(freeGiftLine);
                }
              },
            },
            {
              key: "addFreeGift",
              value: function (variantId) {
                var e = this;
                const requestBody = {
                  items: [
                    {
                      id: variantId,
                      quantity: 1,
                      properties: {
                        _free_gift: "free_gift",
                      },
                    },
                  ],
                };
                window
                  .fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestBody),
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function () {
                    return e.fetchCart();
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: "handleAdditionalUpsell",
              value: function (data) {
                const cartItems = data.items;
                const hiddenUpsells = document.querySelectorAll(
                  ".pwd-upsells-carousel.hidden .pwd-upsells-carousel__item",
                );

                $(".pwd-upsells-carousel.slick-carousel").slick("unslick");

                hiddenUpsells.forEach((hiddenUpsell) => {
                  const parentId = Number(hiddenUpsell.dataset.parentProductId);
                  const variantId = hiddenUpsell.dataset.variantId;
                  const productInCart = cartItems.find(
                    (item) => item.id === parentId,
                  );

                  const carousel = document.querySelector(
                    ".pwd-upsells-carousel.slick-carousel",
                  );
                  if (!carousel) return;
                  const upsellFound = carousel.querySelector(
                    `.pwd-upsells-carousel__item[data-variant-id="${variantId}"]`,
                  );

                  if (productInCart && !upsellFound) {
                    carousel.insertAdjacentElement("beforeend", hiddenUpsell);
                  }
                });

                this.renameUpsellItems();

                initUpsellSlick(); // function location: pwd-upsells.liquid
              },
            },
            {
              key: "renameUpsellItems",
              value: function (data) {
                /* changing upsell titles */
                const allUpsells = document.querySelectorAll(
                  ".pwd-upsells-carousel .pwd-upsells-carousel__item",
                );
                allUpsells.forEach((upsell) => {
                  var upsellTitle = upsell.querySelector(`.title`);
                  let newTitle = "";

                  switch (upsellTitle.innerHTML) {
                    case "Luminance Medical Essential Cleaning Kit":
                      newTitle = "Essential Cleaning Kit";
                      break;
                    case "Extra Fiber Optic Tip - The Luminance RED":
                      newTitle = "Extra Fiber Optic Tip";
                      break;
                    case "Activating Topical System for the Lip Sore Device":
                      newTitle = "Lip Topical System";
                      break;
                    case "Activating Topical System for the Acne Device":
                      newTitle = "Acne Topical System";
                      break;
                    case "Activating Topical System for the Genital Device":
                      newTitle = "Genital Topical System";
                      break;
                    default:
                      newTitle = upsellTitle.innerHTML;
                      break;
                  }
                  upsellTitle.textContent = newTitle;
                });
                /* END changing upsell titles */
              },
            },
          ]) && _defineProperties(t.prototype, e),
          r && _defineProperties(t, r),
          GoCart
        );
      })();
      e.default = h;
    },
  ]).default;
});
//# sourceMappingURL=index.js.map
